import React from "react";
import { Warning, Refresh, Cached } from "@material-ui/icons";
import { useSpringaheadProject } from "./useSpringaheadProject";

export const SpringaheadProjectManagerIndicator = ({
  projectId,
  managerId,
}) => {
  const { isLoading, springaheadProject, refresh } =
    useSpringaheadProject(projectId);

  const onRefresh = (e) => {
    e.preventDefault();
    refresh();
  };

  const isMismatched = springaheadProject?.managerId !== String(managerId);

  if (!springaheadProject) return null;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          fontSize: "10px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {isMismatched && <Warning style={{ fontSize: "11px", color: "red" }} />}
        <span style={{ color: "#666" }}>
          Springahead Project Manager:{" "}
          <a
            href={springaheadProject.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {springaheadProject.managerName}
          </a>
          .
        </span>
        <button
          onClick={onRefresh}
          type="button"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          disabled={isLoading}
        >
          {isLoading ? (
            <Cached style={{ fontSize: "11px" }} />
          ) : (
            <Refresh style={{ fontSize: "11px" }} />
          )}
        </button>
      </div>
      {isMismatched && (
        <div style={{ fontSize: "10px", color: "red" }}>
          The project manager is mismatched. Please update the project manager
          in Springahead before you save this record.
        </div>
      )}
    </div>
  );
};
